package com.macrofocus.eflux.ui

import com.macrofocus.eflux.Languages
import i18next.invoke
import i18next.useTranslation
import mui.icons.material.ExpandMoreTwoTone
import mui.icons.material.TranslateTwoTone
import mui.material.*
import react.FC
import react.Key
import react.PropsWithChildren
import react.ReactNode
import react.dom.events.MouseEvent
import react.useState
import web.dom.ElementId
import web.html.HTMLButtonElement

external interface LanguagesButtonProps : PropsWithChildren {
    var languages: Iterable<Languages>?
}

val LanguagesButton = FC<LanguagesButtonProps> { props ->
    val (t, i) = useTranslation()

    val (languageMenu, setLanguageMenu) = useState<HTMLButtonElement?>(null)

    fun handleIconClick(event: MouseEvent<*, *>) = setLanguageMenu(event.currentTarget as? HTMLButtonElement)
    fun handleMenuClose(event: Any, reason: String) = setLanguageMenu(null)

    Tooltip {
        title = ReactNode(t("appBar.changeLanguage"))

        Button {
            color = ButtonColor.secondary
            ariaLabel = t("appBar.changeLanguage")

            onClick = ::handleIconClick

            TranslateTwoTone {}
            ExpandMoreTwoTone {
                fontSize = SvgIconSize.small
            }
        }
    }

    Menu {
        id = ElementId("language-menu")
        languageMenu?.let { anchorEl = { languageMenu } }
        open = languageMenu != null
        onClose = ::handleMenuClose

        props.languages?.forEach { language ->
            MenuItem {
                key = Key(language.code)
                selected = i.language == language.code
                lang = language.code
                onClick = { event ->
                    i.changeLanguage(language.code)
                    handleMenuClose(event, "")
                }

                +language.label
            }
        }
    }
}